// ABOUTME: A burst of the same notification (same type and title, one after another within an
// hour, e.g. five "Upload failed") reads as one row with its count, so it doesn't push
// everything else off the list.

const BURST_WINDOW_MS = 60 * 60 * 1000

interface Groupable {
  id: string
  type: string
  title: string
  created_at: string
}

export interface NotificationBurst<T extends Groupable> {
  /** The newest of the burst, shown for all of them. */
  notification: T
  ids: string[]
  count: number
}

/** `notifications` (newest first) with each burst folded into its newest row. */
export function groupBursts<T extends Groupable>(notifications: T[]): NotificationBurst<T>[] {
  const bursts: NotificationBurst<T>[] = []
  for (const n of notifications) {
    const last = bursts.at(-1)
    const lastAt = last ? Date.parse(last.notification.created_at) : 0
    if (
      last &&
      last.notification.type === n.type &&
      last.notification.title === n.title &&
      lastAt - Date.parse(n.created_at) <= BURST_WINDOW_MS
    ) {
      last.ids.push(n.id)
      last.count += 1
    } else {
      bursts.push({ notification: n, ids: [n.id], count: 1 })
    }
  }
  return bursts
}
